import { FunctionComponent, lazy, Suspense } from 'react';

import { FeatureConfiguration } from '../../config/FeatureConfiguration';
import { ErrorBoundary } from '../errorBoundary/ErrorBoundary';

interface PromotionSelectorProps {
  drawBasedOn?: HTMLElement | null;
}

const PromotionsOldConnected = lazy(() => import('../promotions_old/PromotionsOldConnected'));
const PromotionsConnected = lazy(() => import('./PromotionsConnected'));

export const PromotionSelector: FunctionComponent<PromotionSelectorProps> = ({ drawBasedOn }) => (
  <ErrorBoundary fallback={<></>}>
    <Suspense>
      {FeatureConfiguration.isOldPromotionsActive ? (
        <PromotionsOldConnected drawBasedOn={drawBasedOn} />
      ) : (
        <PromotionsConnected drawBasedOn={drawBasedOn} />
      )}
    </Suspense>
  </ErrorBoundary>
);
